// Shared contact tags used across Calendar and Contacts
export const AVAILABLE_TAGS = [
  { value: 'artist', label: 'Artist', color: 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-400' },
  { value: 'venue', label: 'Venue', color: 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400' },
  { value: 'promoter', label: 'Promoter', color: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400' },
  { value: 'booking', label: 'Booking Agent', color: 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-400' },
  { value: 'tech', label: 'Tech/Sound', color: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400' },
  { value: 'merch', label: 'Merch', color: 'bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-400' },
  { value: 'press', label: 'Press/Media', color: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400' },
  { value: 'other', label: 'Other', color: 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400' },
];

export const getTagColor = (tagValue) => {
  const tag = AVAILABLE_TAGS.find(t => t.value === tagValue);
  return tag ? tag.color : 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400';
};

export const getTagLabel = (tagValue) => {
  const tag = AVAILABLE_TAGS.find(t => t.value === tagValue);
  return tag ? tag.label : tagValue;
};